import * as React from 'react'
import { observer } from 'mobx-react'
import { Redirect, Route } from 'react-router'
import link from 'infra/link'
import { PayoutsAdminRootViewModel } from '../../PayoutsAdminRootViewModel'
import PayoutReview from '../../review/views/PayoutReview'
import { useDocumentTitle } from '../../../../hooks/document-title'
import TransactionHistory from '../../transaction-history/views/TransactionHistory'

interface PayoutsAdminRootProps {
  vm: PayoutsAdminRootViewModel
}

/**
 * The PayoutsAdminRoot
 */
export default observer(function PayoutsAdminRoot({
  vm,
}: PayoutsAdminRootProps) {
  useDocumentTitle('Payouts')
  return (
    <>
      <Route exact path={link.adminPayouts()}>
        {/* Until we have the Pending view. */}
        <Redirect push={false} to={link.adminPayoutsReview()} />
      </Route>

      <Route path={link.adminPayoutsReview()}>
        <PayoutReview vm={vm.reviewVm} />
      </Route>

      <Route path={link.adminPayoutsTransactions()}>
        <TransactionHistory vm={vm.historyVm} />
      </Route>
    </>
  )
})
